import React from 'react';
import { useAuthContext } from 'context/AuthProvider';
import { PusherHandler } from 'context/pusher';
import { useToast } from '@morressier/alembic';
import {
  BULK_DOWNLOAD_STARTED,
  BULK_DOWNLOAD_SUCCESS,
  BULK_DOWNLOAD_FAILED
} from 'utils/pusher/bulkDownload';

export const GlobalBulkDownloadNotifications: React.FC = () => {
  const userData = useAuthContext();
  const userId = userData?.id;
  const toast = useToast();

  const bulkDownloadStartedEvent = userId && BULK_DOWNLOAD_STARTED(userId);
  const bulkDownloadSuccessEvent = userId && BULK_DOWNLOAD_SUCCESS(userId);
  const bulkDownloadFailedEvent = userId && BULK_DOWNLOAD_FAILED(userId);

  if (!userId) {
    return null;
  }

  return (
    <>
      {bulkDownloadStartedEvent && (
        <PusherHandler
          channel={bulkDownloadStartedEvent.channelName}
          event={bulkDownloadStartedEvent.eventType}
          onUpdate={(payload: unknown) => {
            const data = payload as Record<string, any>;
            toast({
              title:
                data?.message ||
                'Your bulk download has started in the background.',
              variant: 'neutral'
            });
          }}
        />
      )}
      {bulkDownloadSuccessEvent && (
        <PusherHandler
          channel={bulkDownloadSuccessEvent.channelName}
          event={bulkDownloadSuccessEvent.eventType}
          onUpdate={(payload: unknown) => {
            const data = payload as Record<string, any>;
            toast({
              title:
                data?.message ||
                'Bulk download completed! Check your email for the link.',
              variant: 'success'
            });
          }}
        />
      )}
      {bulkDownloadFailedEvent && (
        <PusherHandler
          channel={bulkDownloadFailedEvent.channelName}
          event={bulkDownloadFailedEvent.eventType}
          onUpdate={(payload: unknown) => {
            const data = payload as Record<string, any>;
            toast({
              title:
                data?.message ||
                'Bulk download failed. Please try again or contact support.',
              variant: 'error'
            });
          }}
        />
      )}
    </>
  );
};
